import image1 from "../images/image1.jpg"
import image2 from "../images/image2.jpg"
import image3 from "../images/image3.jpg"
import image4 from "../images/image4.jpg"
import image5 from "../images/image5.jpg"
import image6 from "../images/image6.jpg"

const reviewData = [
    {
        name: '@Bilalhashmi29',
        msge: 'One Stop shop solution for all your need at your doorstep. staying focused on hygiene and sanatization <span class="company-name">@CoreCare</span>',
        image: image1

    },
    {
        name: '@AdityaRPatro',
        msge: `Brilliant Staff <span class="company-name">@afzalSaiyed</span> and to the entire <span class="company-name">@CoreCare</span> Team for stepping up duting uncertain future`,
        image: image2

    },
    {
        name: '@Bhanu82284032',
        msge: `<span class="company-name">@CoreCare</span> You guys rock did'nt expect such exceptional service even in this pandamic situation.`,
        image: image3


    },
    {
        name: '@afzal_saiyed',
        msge: `<span class="company-name">@CoreCare</span> I Appreciate the precautianary measure taken by your servicemen. They were aware of aarogya setup importance..`,
        image: image4

    },
    {
        name: '@sankeyBoy',
        msge: `Had a short circuit in the apartment Electrician visit scheduled in a flash now things are back to normal Thanks to <span class="company-name">@CoreCare</span>`,
        image: image5

    },
    {
        name: '@dhanotiya30',
        msge: `Definately <span class="company-name">@CoreCare</span> is very helpful in this pendemic situation they are providing a hygenic service even during this pandamic situation`,
        image: image6

    },
    {
        name: '@zaidshaikh129',
        msge: 'One Stop shop solution for all your need at your doorstep. staying focused on hygiene and sanatization <span class="company-name">@CoreCare</span>',
        image: image1

    },
    {
        name: '@Arshadshaikh',
        msge: `Brilliant Staff <span class="company-name">@afzalSaiyed</span> and to the entire <span class="company-name">@CoreCare</span> Team for stepping up duting uncertain future`,
        image: image2

    }


]

export default reviewData